import UsersPage from 'components/users/UsersPage';
import { useUserSearchQuery } from 'utils/wemble-api';

const Users = () => {
  const { data: searchResult, isLoading: fetchingUsers } = useUserSearchQuery({ includeAdmins: true, includeUncompleted: true }, { refetchOnMountOrArgChange: true, refetchOnReconnect: true });
  return <UsersPage users={searchResult?.users as any} loading={fetchingUsers} />;
};

export default Users;
